import { reactive } from 'vue';

export const llmBudgetNotice = reactive({ limit: null });

export function showLlmBudgetNotice(payload) {
  if (payload?.code !== 'LLM_BUDGET_EXCEEDED') return false;
  llmBudgetNotice.limit = payload.budget || {};
  return true;
}
